export default __webpack_public_path__ + "static/media/blueRightArrow.52ac0b00.svg";